import { computed, ref, watch } from 'vue'

export type Locale = 'en' | 'th'
export type TranslationParams = Record<string, string | number>

const STORAGE_KEY = 'nongmor.locale'

const thai: Record<string, string> = {
  // Application shell and common actions
  'Dashboard': 'แดชบอร์ด',
  'Maps': 'แผนที่',
  'History': 'ประวัติข้อมูล',
  'Alarms': 'สัญญาณเตือน',
  'Notification': 'การแจ้งเตือน',
  'Notifications': 'การแจ้งเตือน',
  'Thresholds': 'เกณฑ์แจ้งเตือน',
  'Settings': 'ตั้งค่า',
  'Administrator': 'ผู้ดูแลระบบ',
  'User': 'ผู้ใช้งาน',
  'Expand sidebar': 'ขยายแถบเมนู',
  'Collapse sidebar': 'ย่อแถบเมนู',
  'Open menu': 'เปิดเมนู',
  'Close menu': 'ปิดเมนู',
  'Logout': 'ออกจากระบบ',
  'English': 'English',
  'Thai': 'ไทย',
  'Language': 'ภาษา',
  'Refresh': 'โหลดข้อมูลใหม่',
  'Refreshing...': 'กำลังโหลดข้อมูลใหม่...',
  'Updating...': 'กำลังอัปเดต...',
  'Live': 'เรียลไทม์',
  'Loading...': 'กำลังโหลด...',
  'Retry': 'ลองอีกครั้ง',
  'Something went wrong. Please try again.': 'เกิดข้อผิดพลาด กรุณาลองอีกครั้ง',
  'Error Occurred': 'เกิดข้อผิดพลาด',
  'Try Again': 'ลองอีกครั้ง',
  'Hide Details': 'ซ่อนรายละเอียด',
  'Show Details': 'แสดงรายละเอียด',
  'Downloaded {size}': 'ดาวน์โหลดแล้ว {size}',
  'Please do not close or refresh this page until the download finishes.': 'กรุณาอย่าปิดหรือรีเฟรชหน้านี้จนกว่าจะดาวน์โหลดเสร็จ',
  'Save': 'บันทึก',
  'Saving...': 'กำลังบันทึก...',
  'Cancel': 'ยกเลิก',
  'Back': 'กลับ',
  'Next': 'ถัดไป',
  'Previous': 'ก่อนหน้า',
  'First page': 'หน้าแรก',
  'Last page': 'หน้าสุดท้าย',
  'Previous page': 'หน้าก่อนหน้า',
  'Next page': 'หน้าถัดไป',
  'Edit': 'แก้ไข',
  'Delete': 'ลบ',
  'Add': 'เพิ่ม',
  'Search': 'ค้นหา',
  'All': 'ทั้งหมด',
  'Enabled': 'เปิดใช้งาน',
  'Disabled': 'ปิดใช้งาน',
  'Normal': 'ปกติ',
  'Warning': 'คำเตือน',
  'Warnings': 'คำเตือน',
  'Alarm': 'สัญญาณเตือน',
  'Active': 'ใช้งานอยู่',
  'Offline': 'ออฟไลน์',
  'Online': 'ออนไลน์',
  'Unknown': 'ไม่ทราบ',
  'No data': 'ไม่มีข้อมูล',
  'No data available': 'ไม่มีข้อมูล',
  'No current readings': 'ไม่มีค่าการวัดปัจจุบัน',
  'Last report: {time}': 'รายงานล่าสุด: {time}',
  'Last known status: {status}': 'สถานะล่าสุดก่อนออฟไลน์: {status}',
  'Not available': 'ไม่มีข้อมูล',
  'Never': 'ไม่เคย',
  'Yes': 'ใช่',
  'No': 'ไม่',
  'Showing {from}-{to} of {total}': 'แสดง {from}-{to} จาก {total}',
  'Page {page} of {total}': 'หน้า {page} จาก {total}',
  'Page {page} of {pages} ({total} stations total)': 'หน้า {page} จาก {pages} (ทั้งหมด {total} สถานี)',
  'Pagination': 'การแบ่งหน้า',

  // Authentication
  'Power Meter': 'ระบบติดตามค่ามิเตอร์ไฟฟ้า',
  'Sign in to your account': 'เข้าสู่ระบบบัญชีของคุณ',
  'Username': 'ชื่อผู้ใช้',
  'Password': 'รหัสผ่าน',
  'Enter your username': 'กรอกชื่อผู้ใช้',
  'Enter your password': 'กรอกรหัสผ่าน',
  'Show password': 'แสดงรหัสผ่าน',
  'Hide password': 'ซ่อนรหัสผ่าน',
  'Sign in': 'เข้าสู่ระบบ',
  'Signing in...': 'กำลังเข้าสู่ระบบ...',
  'Invalid username or password': 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
  'Sign in failed. Please try again.': 'เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
  'Power Meter Monitoring System': 'ระบบติดตามค่ามิเตอร์ไฟฟ้า',

  // Dashboard
  'MDB Monitoring Dashboard': 'MDB Monitoring Dashboard',
  'EV Stations': 'สถานีชาร์จ EV',
  'Search stations...': 'ค้นหาสถานี...',
  'Grid view': 'มุมมองแบบการ์ด',
  'List view': 'มุมมองรายการ',
  'Station': 'สถานี',
  'Status': 'สถานะ',
  'Power': 'กำลังไฟฟ้า',
  'Voltage': 'แรงดันไฟฟ้า',
  'Current': 'กระแสไฟฟ้า',
  'Energy': 'พลังงาน',
  'Energy today': 'พลังงานวันนี้',
  'Last update': 'อัปเดตล่าสุด',
  'Updated': 'อัปเดต',
  'No stations found': 'ไม่พบสถานี',
  'No stations matching "{query}"': 'ไม่พบสถานีที่ตรงกับ “{query}”',
  'Just now': 'เมื่อสักครู่',
  '1 min ago': '1 นาทีที่แล้ว',
  '{count} min ago': '{count} นาทีที่แล้ว',
  '{count} sec ago': '{count} วินาทีที่แล้ว',
  '{count} hr ago': '{count} ชั่วโมงที่แล้ว',
  'Updated {time}': 'อัปเดต {time}',
  'Total Power': 'กำลังไฟฟ้ารวม',
  'Active Stations': 'สถานีที่ออนไลน์',
  'Total Stations': 'สถานีทั้งหมด',
  'Protection Alarms': 'สัญญาณเตือนอุปกรณ์ป้องกัน',
  'Stations': 'สถานี',
  'All Clear': 'ปกติทั้งหมด',
  'need attention': 'ต้องตรวจสอบ',
  'No warnings': 'ไม่มีคำเตือน',
  'Latest:': 'ล่าสุด:',
  'Monitored:': 'เฝ้าติดตาม:',
  'Power Factor': 'ตัวประกอบกำลัง (PF)',
  'High': 'สูง',
  'Medium': 'ปานกลาง',
  'Low': 'ต่ำ',
  '{count} meter': '{count} มิเตอร์',
  '{count} meters': '{count} มิเตอร์',
  'ACTIVE': 'ใช้งานอยู่',
  'WARNING': 'คำเตือน',
  'ALERT': 'สัญญาณเตือน',
  'ERROR': 'ขัดข้อง',
  'OFFLINE': 'ออฟไลน์',
  'NORMAL': 'ปกติ',

  // Device diagnostics
  'Diagnostics capable': 'รองรับการวิเคราะห์',
  'Diagnostics disabled': 'ปิดการวิเคราะห์',
  'Diagnostics shadow': 'โหมดเฝ้าสังเกต',
  'Topology error': 'โครงสร้างมิเตอร์ไม่ถูกต้อง',
  'Diagnostics unavailable': 'การวิเคราะห์ยังไม่พร้อมใช้งาน',
  'Diagnostics: waiting for capability data': 'การวิเคราะห์: รอข้อมูลยืนยันจากอุปกรณ์',
  'Diagnostics topology error': 'การวิเคราะห์: โครงสร้างมิเตอร์ไม่ถูกต้อง',
  'Diagnostics configuration unavailable': 'การวิเคราะห์: ยังไม่ได้ตั้งค่า',
  'Diagnostics capable but disabled': 'รองรับการวิเคราะห์แต่ปิดใช้งาน',
  'Diagnostics shadow mode': 'การวิเคราะห์ในโหมดเฝ้าสังเกต',
  'Diagnostics active': 'กำลังวิเคราะห์สถานะ',
  'Diagnostic evidence': 'หลักฐานการวิเคราะห์',
  'Diagnostic overview': 'ภาพรวมการวิเคราะห์',
  'Last evaluated': 'ประเมินล่าสุด',
  'Diagnostic readiness': 'ความพร้อมในการวิเคราะห์',
  'Offline after {seconds} seconds without meter data': 'ถือว่าออฟไลน์เมื่อไม่มีข้อมูลมิเตอร์ {seconds} วินาที',
  'Firmware signal': 'ข้อมูลยืนยันจากเฟิร์มแวร์',
  'Capability detected': 'อุปกรณ์รองรับการวิเคราะห์',
  'Waiting for capability': 'รอข้อมูลยืนยันจากอุปกรณ์',
  'enabled_alarms is present in live data.': 'พบ enabled_alarms ในข้อมูลปัจจุบัน',
  'Requires enabled_alarms in a data message.': 'ต้องมี enabled_alarms ในข้อความข้อมูล',
  'Meter topology': 'โครงสร้างมิเตอร์',
  'Power path ready': 'พร้อมตรวจสอบเส้นทางไฟฟ้า',
  'Topology unavailable': 'ข้อมูลการจัดวางมิเตอร์ไม่พร้อม',
  '1 main meter and {count} downstream meter.': 'มิเตอร์หลัก 1 ตัว และมิเตอร์วงจรย่อย {count} ตัว',
  '1 main meter and {count} downstream meters.': 'มิเตอร์หลัก 1 ตัว และมิเตอร์วงจรย่อย {count} ตัว',
  'Waiting for registered meter readings.': 'รอข้อมูลจากมิเตอร์ที่ลงทะเบียน',
  'Evaluation mode': 'โหมดการประเมิน',
  'Shadow monitoring': 'โหมดเฝ้าสังเกต',
  'Live diagnostics': 'การวิเคราะห์แบบใช้งานจริง',
  'Evidence is visible, but inferred notifications stay off.': 'แสดงหลักฐาน แต่ยังไม่ส่งการแจ้งเตือนจากการวิเคราะห์',
  'Confirmed conditions can create diagnostic warnings.': 'เหตุที่ยืนยันแล้วสามารถสร้างคำเตือนการวิเคราะห์ได้',
  'Station power path': 'เส้นทางกำลังไฟฟ้าของสถานี',
  'Live readings are arranged by their physical position around the main breaker.': 'จัดค่าปัจจุบันตามตำแหน่งจริงก่อนและหลังเมนเบรกเกอร์',
  'Review': 'ควรตรวจสอบ',
  'Probable fault': 'มีแนวโน้มขัดข้อง',
  'Incoming supply': 'ไฟฟ้าขาเข้า',
  'Supply unavailable': 'ไม่พบไฟฟ้าขาเข้า',
  'Supply present': 'มีไฟฟ้าขาเข้า',
  'Waiting for readings': 'รอข้อมูลมิเตอร์',
  'Main meter · before breaker': 'มิเตอร์หลัก · ก่อนเมนเบรกเกอร์',
  'Waiting for m1': 'รอข้อมูล m1',
  'Main breaker': 'เมนเบรกเกอร์',
  'Path available': 'เส้นทางพร้อมใช้งาน',
  'Probable trip': 'มีแนวโน้มทริป',
  'Check downstream': 'ตรวจสอบวงจรย่อย',
  'Downstream branch · after breaker': 'วงจรย่อย · หลังเมนเบรกเกอร์',
  'Waiting for downstream meter readings.': 'รอข้อมูลจากมิเตอร์วงจรย่อย',
  'Charging': 'กำลังชาร์จ',
  'Standby': 'สแตนด์บาย',
  'No reading': 'ไม่มีค่าที่อ่านได้',
  'Not evaluated yet': 'ยังไม่ประเมิน',
  'No charging for longer than expected': 'ไม่พบการชาร์จนานกว่าที่กำหนด',
  'Charging activity detected': 'ตรวจพบกิจกรรมชาร์จ',
  'Station is currently in standby': 'ขณะนี้สถานีอยู่ในโหมดสแตนด์บาย',
  'Waiting for branch power data': 'รอข้อมูลกำลังไฟฟ้าของวงจรย่อย',
  'A site inspection is recommended.': 'แนะนำให้เข้าตรวจสอบสถานที่',
  'At least one downstream meter is above 1.0 kW.': 'มิเตอร์วงจรย่อยอย่างน้อยหนึ่งตัวมีกำลังไฟฟ้าสูงกว่า 1.0 kW',
  '{duration} without EV charging; review at {threshold}.': 'ไม่พบการชาร์จ EV เป็นเวลา {duration}; ตรวจสอบเมื่อครบ {threshold}',
  'Charging activity is evaluated only from valid downstream kW readings.': 'ประเมินการชาร์จจากค่า kW ที่ถูกต้องของมิเตอร์วงจรย่อยเท่านั้น',
  'Waiting for diagnostic data': 'รอข้อมูลการวิเคราะห์',
  'Firmware capability not detected': 'ยังไม่พบข้อมูลยืนยันจากเฟิร์มแวร์',
  'Meter topology needs attention': 'ต้องตรวจสอบโครงสร้างมิเตอร์',
  'Diagnostic warning': 'คำเตือนจากการวิเคราะห์',
  'Diagnostic advisory': 'ข้อแนะนำจากการวิเคราะห์',
  'A condition needs prompt attention.': 'พบความผิดปกติที่ควรตรวจสอบโดยเร็ว',
  'Please review this condition.': 'กรุณาตรวจสอบความผิดปกตินี้',
  '{count} condition needs attention': 'มี {count} เหตุที่ต้องตรวจสอบ',
  '{count} conditions need attention': 'มี {count} เหตุที่ต้องตรวจสอบ',
  'No diagnostic issue detected': 'ไม่พบปัญหาจากการวิเคราะห์',
  'The visual diagnosis will appear after the first data message.': 'ระบบจะแสดงผลการวิเคราะห์หลังได้รับข้อความข้อมูลครั้งแรก',
  'The latest data messages do not contain the enabled_alarms capability key.': 'ข้อความข้อมูลล่าสุดไม่มีคีย์ enabled_alarms',
  'Shadow mode is observing conditions without publishing inferred alerts.': 'โหมดเฝ้าสังเกตกำลังติดตามสถานะ โดยยังไม่ส่งการแจ้งเตือนจากผลวิเคราะห์',
  'Live meter topology and diagnostic rules are being evaluated.': 'กำลังประเมินโครงสร้างมิเตอร์และกฎการวิเคราะห์จากข้อมูลปัจจุบัน',
  'Charging threshold': 'เกณฑ์การชาร์จ',
  'per branch': 'ต่อวงจรย่อย',
  '{duration} observed': 'ตรวจพบต่อเนื่อง {duration}',
  'Review at {duration}': 'ตรวจสอบเมื่อครบ {duration}',
  'Timer starts when every branch is at or below 1.0 kW': 'เริ่มจับเวลาเมื่อทุกวงจรย่อยมีกำลังไฟฟ้าไม่เกิน 1.0 kW',
  'A gap over {seconds}s restarts the timer': 'หากข้อมูลขาดเกิน {seconds} วินาที จะเริ่มจับเวลาใหม่',
  'Conditions being checked': 'เหตุที่ระบบกำลังตรวจสอบ',
  'Each card summarizes the latest evidence without exposing raw device JSON.': 'แต่ละการ์ดสรุปหลักฐานล่าสุดโดยไม่แสดง JSON ดิบจากอุปกรณ์',
  '{count} need attention': 'ต้องตรวจสอบ {count} รายการ',
  'All clear': 'ปกติทั้งหมด',
  'No diagnostic evidence yet': 'ยังไม่มีหลักฐานการวิเคราะห์',
  'Evidence appears after a valid data message containing enabled_alarms.': 'หลักฐานจะแสดงหลังได้รับข้อความข้อมูลที่ถูกต้องและมี enabled_alarms',
  'Main breaker trip': 'เมนเบรกเกอร์ทริป',
  'Possible main breaker trip or downstream communication/power loss': 'เมนเบรกเกอร์อาจทริป หรือวงจรย่อยอาจขาดไฟ/ขาดการสื่อสาร',
  'Incoming supply loss': 'ไฟฟ้าขาเข้าขาดหาย',
  'Station meter communication': 'การสื่อสารกับมิเตอร์ภายในสถานี',
  'Charging activity': 'กิจกรรมชาร์จ',
  '{duration} without charging activity': 'ไม่พบกิจกรรมชาร์จเป็นเวลา {duration}',
  '{count} downstream meter unavailable with a physical alarm': 'มิเตอร์วงจรย่อย {count} ตัวไม่ตอบสนอง และอุปกรณ์ป้องกันส่งสัญญาณเตือน',
  '{count} downstream meters unavailable with a physical alarm': 'มิเตอร์วงจรย่อย {count} ตัวไม่ตอบสนอง และอุปกรณ์ป้องกันส่งสัญญาณเตือน',
  'Main and downstream meter paths are consistent': 'มิเตอร์หลักและมิเตอร์วงจรย่อยแสดงเส้นทางไฟฟ้าสอดคล้องกัน',
  '{invalid} of {expected} downstream meters unavailable': 'มิเตอร์วงจรย่อยไม่ตอบสนอง {invalid} จาก {expected} ตัว',
  'All expected downstream meters are responding': 'มิเตอร์วงจรย่อยตอบสนองครบทุกตัว',
  'Incoming voltage and downstream readings are unavailable': 'ไม่พบแรงดันไฟฟ้าขาเข้าและค่าจากวงจรย่อย',
  'Incoming supply is present': 'มีไฟฟ้าขาเข้า',
  'Essential readings are unavailable across the station': 'มิเตอร์ทั้งสถานีไม่มีค่าที่จำเป็นสำหรับการวิเคราะห์',
  'Station meters are communicating': 'มิเตอร์ภายในสถานีสื่อสารได้ตามปกติ',
  'Condition detected from live meter evidence': 'ตรวจพบเหตุจากหลักฐานมิเตอร์ปัจจุบัน',
  'No matching condition detected': 'ไม่พบเหตุที่ตรงตามเงื่อนไข',
  'Probable': 'มีแนวโน้มสูง',
  'Possible': 'อาจเกิดขึ้น',
  'Paused': 'พักการประเมิน',
  'Clear': 'ปกติ',
  'Live station reasoning from meter behavior': 'วิเคราะห์สถานะปัจจุบันจากข้อมูลของมิเตอร์',
  'Diagnostic state is not available yet.': 'ยังไม่มีสถานะการวิเคราะห์',
  'No diagnostic candidates at this time.': 'ขณะนี้ไม่พบเหตุผิดปกติที่ควรตรวจสอบ',
  'Confidence': 'ความมั่นใจ',
  'Evidence': 'หลักฐาน',
  'Observed': 'ค่าที่ตรวจพบ',
  'Expected': 'ค่าที่คาดหมาย',
  'Duration': 'ระยะเวลา',
  'First seen': 'พบครั้งแรก',
  'Last seen': 'พบล่าสุด',
  'Main meter': 'มิเตอร์หลัก',
  'Branch meter': 'มิเตอร์วงจรย่อย',
  'Branch meters': 'มิเตอร์วงจรย่อย',
  'Candidate issue': 'เหตุที่อาจเกิดขึ้น',
  'Possible main breaker trip': 'เมนเบรกเกอร์อาจทริป',
  'Possible branch breaker trip': 'เบรกเกอร์ย่อยอาจทริป',
  'Possible phase loss': 'อาจเกิดไฟขาดเฟส',
  'Extended no charging activity': 'ไม่พบกิจกรรมชาร์จเป็นเวลานาน',
  'Communication timeout': 'มิเตอร์ไม่ตอบสนองภายในเวลาที่กำหนด',
  'No charging activity': 'ไม่มีกิจกรรมชาร์จ',
  'Healthy': 'ปกติ',
  'Monitoring': 'กำลังติดตามสถานะ',
  'Insufficient evidence': 'หลักฐานยังไม่เพียงพอ',
  'Board': 'บอร์ด',
  'Firmware': 'เฟิร์มแวร์',
  'Hardware': 'ฮาร์ดแวร์',
  'Unknown board': 'ไม่ทราบรุ่นบอร์ด',
  'Meter last reported {time}': 'มิเตอร์ส่งข้อมูลล่าสุด {time}',
  'Station offline': 'สถานีออฟไลน์',
  'Open station {station}': 'เปิดสถานี {station}',
  'No readings received since {time}. Current values are hidden because they are not live.': 'ไม่ได้รับข้อมูลตั้งแต่ {time} ค่าปัจจุบันถูกซ่อนไว้เนื่องจากไม่ใช่ข้อมูลสด',
  'Current readings are unavailable while the station is offline.': 'ไม่สามารถแสดงค่าการวัดปัจจุบันได้ขณะที่สถานีออฟไลน์',
  'The station page will resume automatically after new data is received.': 'หน้าสถานีจะแสดงข้อมูลอีกครั้งโดยอัตโนมัติเมื่อได้รับข้อมูลใหม่',
  'No meter data yet': 'ยังไม่มีข้อมูลจากมิเตอร์',
  'Back to dashboard': 'กลับหน้าแดชบอร์ด',
  'Refresh station data': 'โหลดข้อมูลสถานีใหม่',
  'Protectors': 'อุปกรณ์ป้องกัน',
  'FAULT': 'ขัดข้อง',
  'Voltage L-N': 'แรงดันเฟส-นิวทรัล',
  'Voltage L-L': 'แรงดันระหว่างเฟส',
  'Power & Energy': 'กำลังและพลังงาน',
  'Phase Power': 'กำลังไฟฟ้าแต่ละเฟส',
  'Phase PF': 'ตัวประกอบกำลังแต่ละเฟส',
  'Power Quality': 'คุณภาพไฟฟ้า',
  'Neutral': 'นิวทรัล',
  'Frequency': 'ความถี่',
  'Active Energy': 'พลังงานแอกทีฟ',
  'Reactive Energy': 'พลังงานรีแอกทีฟ',
  'Total': 'รวม',
  'Peak Demand': 'ความต้องการกำลังไฟฟ้าสูงสุด',
  'Previous meter': 'มิเตอร์ก่อนหน้า',
  'Next meter': 'มิเตอร์ถัดไป',

  // Charts and history
  'Power trend': 'แนวโน้มกำลังไฟฟ้า',
  'Power Trend (Today 00:00 - 23:59)': 'แนวโน้มกำลังไฟฟ้า (วันนี้ 00:00 - 23:59)',
  'Power (kW)': 'กำลังไฟฟ้า (kW)',
  'Power: {value} kW': 'กำลังไฟฟ้า: {value} kW',
  'Data fetched {time}': 'ดึงข้อมูลเมื่อ {time}',
  'Historical': 'ข้อมูลย้อนหลัง',
  'No readings received today': 'วันนี้ยังไม่ได้รับข้อมูล',
  'Missing periods are left blank and are not counted as zero.': 'ช่วงเวลาที่ไม่มีข้อมูลจะเว้นว่างและไม่นับเป็นศูนย์',
  'The most recent successful server fetch; this differs from the meter reading time.': 'เวลาที่ดึงข้อมูลจากเซิร์ฟเวอร์สำเร็จล่าสุด ซึ่งต่างจากเวลาที่มิเตอร์วัดค่า',
  'Today': 'วันนี้',
  'Yesterday': 'เมื่อวาน',
  'Last 7 Days': '7 วันล่าสุด',
  'Last 30 Days': '30 วันล่าสุด',
  'Last 60 Days': '60 วันล่าสุด',
  'Last 90 Days': '90 วันล่าสุด',
  'Peak': 'สูงสุด',
  'Average': 'เฉลี่ย',
  'Minimum': 'ต่ำสุด',
  'No power data available': 'ไม่มีข้อมูลกำลังไฟฟ้า',
  'Historical Data': 'ข้อมูลย้อนหลัง',
  'Metric': 'ค่าที่วัด',
  'Date Range': 'ช่วงวันที่',
  'Export Raw Data': 'ส่งออกข้อมูลดิบ',
  'Lowest': 'ต่ำสุด',
  'Latest': 'ล่าสุด',
  'from {count} points': 'จาก {count} จุด',
  '{count} meters combined': 'รวม {count} มิเตอร์',
  'Averaged every {count} hours': 'เฉลี่ยทุก {count} ชั่วโมง',
  'Averaged every {count} minutes': 'เฉลี่ยทุก {count} นาที',
  'Request timed out. Try selecting a shorter date range.': 'คำขอหมดเวลา กรุณาเลือกช่วงวันที่สั้นลง',
  'Server error. Please try again or select a different station.': 'เซิร์ฟเวอร์ขัดข้อง กรุณาลองใหม่หรือเลือกสถานีอื่น',
  'Session expired. Please refresh the page.': 'เซสชันหมดอายุ กรุณารีเฟรชหน้า',
  'Failed to fetch history data. Please try again.': 'โหลดข้อมูลย้อนหลังไม่สำเร็จ กรุณาลองใหม่',
  'A download is in progress. Cancel it before leaving this page.': 'กำลังดาวน์โหลด กรุณายกเลิกก่อนออกจากหน้านี้',
  'Export completed successfully!': 'ส่งออกข้อมูลสำเร็จ',
  'Download canceled.': 'ยกเลิกการดาวน์โหลดแล้ว',
  'Failed to export. Please try again.': 'ส่งออกไม่สำเร็จ กรุณาลองใหม่',
  'Creating file...': 'กำลังสร้างไฟล์…',
  'Select a station first': 'กรุณาเลือกสถานีก่อน',
  'No data in the selected period': 'ไม่มีข้อมูลในช่วงที่เลือก',
  'Download calculated values (7 columns) from {start} to {end}': 'ดาวน์โหลดค่าที่คำนวณแล้ว (7 คอลัมน์) ตั้งแต่ {start} ถึง {end}',
  'Download every raw column reported by the meter from {start} to {end}': 'ดาวน์โหลดข้อมูลดิบทุกคอลัมน์ที่มิเตอร์ส่งมา ตั้งแต่ {start} ถึง {end}',
  'Preparing raw data file': 'กำลังเตรียมไฟล์ข้อมูลดิบ',
  'Preparing CSV file': 'กำลังเตรียมไฟล์ CSV',
  '{start} to {end}': '{start} ถึง {end}',
  'Select station': 'เลือกสถานี',
  'Select meter': 'เลือกมิเตอร์',
  'Select Station': 'เลือกสถานี',
  'All Meters': 'มิเตอร์ทั้งหมด',
  'No stations found for "{query}"': 'ไม่พบสถานีสำหรับ “{query}”',
  'No meters found': 'ไม่พบมิเตอร์',
  'Select a station': 'เลือกสถานี',
  'Select a meter': 'เลือกมิเตอร์',
  'Date range': 'ช่วงวันที่',
  'Quick Select': 'เลือกช่วงด่วน',
  'Custom Range': 'กำหนดช่วงเอง',
  'Start': 'เริ่มต้น',
  'End': 'สิ้นสุด',
  'Apply': 'นำไปใช้',
  'Apply Range': 'ใช้ช่วงวันที่',
  'Select date range': 'เลือกช่วงวันที่',
  'Max {days} days': 'สูงสุด {days} วัน',
  'Start date must be before end date': 'วันที่เริ่มต้นต้องมาก่อนวันที่สิ้นสุด',
  'Cannot query data older than {days} days': 'ไม่สามารถเรียกข้อมูลย้อนหลังเกิน {days} วัน',
  'End date cannot be in the future': 'วันที่สิ้นสุดต้องไม่อยู่ในอนาคต',
  'Last 24 hours': '24 ชั่วโมงล่าสุด',
  'Last 7 days': '7 วันล่าสุด',
  'Last 30 days': '30 วันล่าสุด',
  'Export CSV': 'ส่งออก CSV',
  'Voltage alarm periods': 'ช่วงแรงดันผิดปกติ',
  'No history data for the selected period.': 'ไม่มีข้อมูลย้อนหลังในช่วงที่เลือก',
  'There is no meter data for the selected period.': 'ไม่มีข้อมูลมิเตอร์ในช่วงเวลาที่เลือก',
  'Try the following:': 'ลองดำเนินการดังนี้:',
  'Adjust the date range': 'ปรับช่วงวันที่',
  'Select a different station': 'เลือกสถานีอื่น',
  'Check if the meters are active': 'ตรวจสอบว่ามิเตอร์ยังทำงานอยู่',
  'Meters (click to toggle)': 'มิเตอร์ (คลิกเพื่อแสดงหรือซ่อน)',
  'OVPR — over-voltage': 'OVPR — แรงดันเกิน',
  'UVPR — under-voltage': 'UVPR — แรงดันต่ำ',
  'Over Voltage ({value}V)': 'แรงดันเกิน ({value}V)',
  'Under Voltage ({value}V)': 'แรงดันต่ำ ({value}V)',
  'Min PF ({value})': 'PF ต่ำสุด ({value})',

  // Alarm page
  'Alarm Center': 'ศูนย์สัญญาณเตือน',
  'Active alarms': 'สัญญาณเตือนที่ยังทำงาน',
  'Alarm history': 'ประวัติสัญญาณเตือน',
  'Type': 'ประเภท',
  'Meter': 'มิเตอร์',
  'Started': 'เริ่มเมื่อ',
  'Ended': 'สิ้นสุดเมื่อ',
  'Value': 'ค่า',
  'Severity': 'ระดับความรุนแรง',
  'No active alarms': 'ไม่มีสัญญาณเตือนที่ยังทำงาน',
  'No alarm history': 'ไม่มีประวัติสัญญาณเตือน',
  'Active Alarms': 'สัญญาณเตือนที่ยังทำงาน',
  'Active Warnings': 'คำเตือนที่ยังทำงาน',
  'Stations Affected': 'สถานีที่ได้รับผลกระทบ',
  'items (one station can have multiple items)': 'รายการ (หนึ่งสถานีอาจมีหลายรายการ)',
  'Ground Fault (GFR)': 'กระแสรั่วลงดิน (GFR)',
  'Over-Voltage (OVPR)': 'แรงดันเกิน (OVPR)',
  'Under-Voltage (UVPR)': 'แรงดันต่ำ (UVPR)',
  'Click to clear': 'คลิกเพื่อล้างตัวกรอง',
  'Click to filter': 'คลิกเพื่อกรอง',
  'Showing {type} alarms ({count} items)': 'กำลังแสดงสัญญาณเตือน {type} ({count} รายการ)',
  'Clear filter': 'ล้างตัวกรอง',
  '{count} active': 'กำลังเกิดอยู่ {count} รายการ',
  '{count} total log items': 'บันทึกทั้งหมด {count} รายการ',
  'No.': 'ลำดับ',
  'Protector': 'อุปกรณ์ป้องกัน',
  'Triggered': 'เริ่มแจ้งเตือน',
  'Cleared': 'สิ้นสุดแล้ว',
  'No {type} alarms in log': 'ไม่มีสัญญาณเตือน {type} ในบันทึก',
  'No protection alarms in log': 'ไม่มีสัญญาณเตือนอุปกรณ์ป้องกันในบันทึก',
  'Measurement': 'ค่าที่วัดได้',
  'No warnings in log': 'ไม่มีคำเตือนในบันทึก',
  'All meters operating normally': 'มิเตอร์ทั้งหมดทำงานปกติ',

  // Map
  'Station Map': 'แผนที่สถานี',
  'Overview': 'ภาพรวม',
  'Real-time station monitoring map': 'แผนที่ตรวจสอบสถานีแบบเรียลไทม์',
  'Failed to fetch station data': 'โหลดข้อมูลสถานีไม่สำเร็จ',
  'Failed to fetch alarms': 'โหลดสัญญาณเตือนไม่สำเร็จ',
  'Failed to fetch warnings': 'โหลดคำเตือนไม่สำเร็จ',
  'Failed to fetch summary': 'โหลดข้อมูลสรุปไม่สำเร็จ',
  'Failed to fetch station status': 'โหลดสถานะสถานีไม่สำเร็จ',
  'Failed to fetch station': 'โหลดข้อมูลสถานีไม่สำเร็จ',
  'Failed to fetch chart data': 'โหลดข้อมูลกราฟไม่สำเร็จ',
  'Failed to load threshold settings': 'โหลดค่าเกณฑ์ไม่สำเร็จ',
  'This station configuration has not been loaded yet': 'ยังไม่ได้โหลดการตั้งค่าของสถานีนี้',
  'Updated: {time}': 'อัปเดต: {time}',
  'Show only {status} stations': 'แสดงเฉพาะสถานะ {status}',
  'Show all stations': 'แสดงทุกสถานี',
  'Click again to clear': 'กดอีกครั้งเพื่อล้าง',
  'Show all': 'แสดงทั้งหมด',
  'Showing {visible} of {total} stations': 'แสดง {visible} จาก {total} สถานี',
  '{count} stations have no coordinates and are hidden from the map': '{count} สถานียังไม่ได้ตั้งพิกัด จึงไม่แสดงบนแผนที่',
  'Loading map...': 'กำลังโหลดแผนที่...',
  'No stations match the filters': 'ไม่มีสถานีที่ตรงกับเงื่อนไข',
  'No stations with coordinates have the selected status.': 'ไม่มีสถานีที่มีพิกัดในสถานะที่เลือก',
  '{count} days ago': '{count} วันที่แล้ว',
  'Meters': 'มิเตอร์',
  'View Details': 'ดูรายละเอียด',
  'Stations on map': 'สถานีบนแผนที่',
  'View station': 'ดูสถานี',
  'No station coordinates available': 'ไม่มีพิกัดสถานี',

  // Notifications
  'Notification Settings': 'ตั้งค่าการแจ้งเตือน',
  'Configure recipients for alarm and warning start/resolution events. Emails are sent automatically.': 'กำหนดผู้รับอีเมลเมื่อเกิดสัญญาณเตือนหรือคำเตือน และเมื่อสถานะกลับสู่ปกติ',
  'Recipients': 'ผู้รับการแจ้งเตือน',
  'All recipients': 'ผู้รับทั้งหมด',
  'Inactive': 'ปิดอยู่',
  'Add recipient': 'เพิ่มผู้รับ',
  'Edit recipient': 'แก้ไขผู้รับแจ้งเตือน',
  'Add notification recipient': 'เพิ่มผู้รับแจ้งเตือน',
  'Recipient': 'ผู้รับ',
  'Scope': 'ขอบเขต',
  'Manage': 'จัดการ',
  'Name': 'ชื่อ',
  'Display name (optional)': 'ชื่อเรียก (ไม่บังคับ)',
  'For example, Shift supervisor A': 'เช่น หัวหน้ากะ A',
  'Email': 'อีเมล',
  'Phone': 'โทรศัพท์',
  'Channel': 'ช่องทาง',
  'Station scope': 'ขอบเขตสถานี',
  'All stations': 'ทุกสถานี',
  'Select “All stations” to receive alerts from every location, including stations added later.': 'เลือก “ทุกสถานี” เพื่อรับแจ้งเตือนจากทุกแห่ง รวมถึงสถานีที่เพิ่มภายหลัง',
  'Active (receive notifications)': 'เปิดใช้งาน (รับการแจ้งเตือน)',
  'Actions': 'การดำเนินการ',
  'Test notification': 'ทดสอบการแจ้งเตือน',
  'Test email': 'ทดสอบส่งอีเมล',
  'Send a sample email to verify that email delivery is working (administrators only).': 'ส่งอีเมลตัวอย่างเพื่อตรวจสอบระบบส่งอีเมล (เฉพาะผู้ดูแลระบบ)',
  'Send to': 'ส่งไปที่',
  'Send a sample in the same format as a real notification to verify email delivery.': 'ส่งอีเมลตัวอย่างในรูปแบบเดียวกับการแจ้งเตือนจริง เพื่อตรวจสอบระบบส่งอีเมล',
  'The email is clearly marked as a test and is not saved in notification history.': 'อีเมลจะระบุชัดเจนว่าเป็นการทดสอบ และจะไม่บันทึกในประวัติการแจ้งเตือน',
  'Sending...': 'กำลังส่ง...',
  'Send test': 'ส่งทดสอบ',
  'Invalid email format': 'รูปแบบอีเมลไม่ถูกต้อง',
  'Failed to send test email': 'ส่งอีเมลทดสอบไม่สำเร็จ',
  'Failed to load notification recipients': 'โหลดรายชื่อผู้รับแจ้งเตือนไม่สำเร็จ',
  'Please enter {field}': 'กรุณากรอก{field}',
  'Notification recipient saved': 'บันทึกผู้รับแจ้งเตือนแล้ว',
  'Notification recipient added': 'เพิ่มผู้รับแจ้งเตือนแล้ว',
  'Save failed': 'บันทึกไม่สำเร็จ',
  'Failed to update status': 'อัปเดตสถานะไม่สำเร็จ',
  'Deleted': 'ลบแล้ว',
  'Delete failed': 'ลบไม่สำเร็จ',
  'No active recipient covers all stations. Stations without a specific recipient will not send notifications to anyone.': 'ยังไม่มีผู้รับที่ครอบคลุมทุกสถานี สถานีที่ไม่ได้ระบุผู้รับไว้โดยเฉพาะจะไม่มีผู้ได้รับการแจ้งเตือน',
  'Active — click to disable': 'กำลังใช้งาน — กดเพื่อปิด',
  'Inactive — click to enable': 'ปิดใช้งาน — กดเพื่อเปิด',
  'Two emails are sent for each event: ALERT when an alarm/warning starts and RESOLVED when it returns to normal. Inactive recipients are skipped.': 'แต่ละเหตุการณ์จะส่งอีเมล 2 ครั้ง: เมื่อเริ่มเกิดเหตุ (ALERT) และเมื่อกลับสู่ปกติ (RESOLVED) โดยจะไม่ส่งถึงผู้รับที่ปิดใช้งาน',
  'No recipients match the filter': 'ไม่มีผู้รับที่ตรงกับตัวกรอง',
  'No notification recipients yet': 'ยังไม่มีผู้รับแจ้งเตือน',
  'Add a recipient to start receiving alarm and warning emails.': 'เพิ่มผู้รับเพื่อรับอีเมลสัญญาณเตือนและคำเตือน',
  'Delete notification recipient': 'ลบผู้รับแจ้งเตือน',
  '{name} will stop receiving notification emails. This action cannot be undone.': '{name} จะไม่ได้รับอีเมลแจ้งเตือนอีก และไม่สามารถย้อนกลับการลบได้',
  'Deleting...': 'กำลังลบ...',

  // Settings
  'Station Settings': 'ตั้งค่าสถานี',
  'Manage station configurations and ESP mappings': 'จัดการการตั้งค่าสถานีและการจับคู่ข้อมูล ESP',
  'Add station': 'เพิ่มสถานี',
  'Add Station': 'เพิ่มสถานี',
  'Edit station': 'แก้ไขสถานี',
  'Edit Station': 'แก้ไขสถานี',
  'Add New Station': 'เพิ่มสถานีใหม่',
  'Update station configuration': 'อัปเดตการตั้งค่าสถานี',
  'Configure a new station for ESP data mapping': 'ตั้งค่าสถานีใหม่สำหรับจับคู่ข้อมูล ESP',
  'Failed to load data': 'โหลดข้อมูลไม่สำเร็จ',
  'Failed to save station': 'บันทึกสถานีไม่สำเร็จ',
  'Station Info': 'ข้อมูลสถานี',
  'Protection': 'อุปกรณ์ป้องกัน',
  'Station Information': 'ข้อมูลสถานี',
  'Station Name': 'ชื่อสถานี',
  'Station Code (ESP ID)': 'รหัสสถานี (ESP ID)',
  'Must match the “station” field in ESP data': 'ต้องตรงกับฟิลด์ “station” ในข้อมูล ESP',
  'Station Ref No.': 'เลขประจำสถานี',
  'Optional station reference number': 'เลขประจำสถานี (ถ้ามี สามารถเว้นว่างได้)',
  'Region Code': 'รหัสภูมิภาค',
  'Station is active': 'สถานีเปิดใช้งาน',
  'Protection Settings': 'ตั้งค่าอุปกรณ์ป้องกัน',
  'Add Protector': 'เพิ่มอุปกรณ์ป้องกัน',
  'Protector {number}': 'อุปกรณ์ป้องกัน {number}',
  'Protector ID': 'รหัสอุปกรณ์ป้องกัน',
  'Auto-generated from Station Code': 'สร้างอัตโนมัติจากรหัสสถานี',
  'Meter Configuration': 'ตั้งค่ามิเตอร์',
  'Add Meter': 'เพิ่มมิเตอร์',
  'Meter {number}': 'มิเตอร์ {number}',
  'Main': 'หลัก',
  'Meter ID': 'รหัสมิเตอร์',
  'Auto-generated from Node Name': 'สร้างอัตโนมัติจากชื่อโหนด',
  'Display Name': 'ชื่อที่แสดง',
  'Main Meter': 'มิเตอร์หลัก',
  'Used for Power Chart': 'ใช้สำหรับกราฟกำลังไฟฟ้า',
  'Review & Confirm': 'ตรวจสอบและยืนยัน',
  'Name:': 'ชื่อ:',
  'Code:': 'รหัส:',
  'Ref No.:': 'เลขอ้างอิง:',
  'Region:': 'ภูมิภาค:',
  'Status:': 'สถานะ:',
  'Coordinates:': 'พิกัด:',
  'Update Station': 'อัปเดตสถานี',
  'Create Station': 'สร้างสถานี',
  'Station name': 'ชื่อสถานี',
  'Station Code': 'รหัสสถานี',
  'Ref No.': 'เลขอ้างอิง',
  'Region': 'ภูมิภาค',
  'Failed to fetch stations': 'โหลดรายการสถานีไม่สำเร็จ',
  'Failed to delete station': 'ลบสถานีไม่สำเร็จ',
  'Showing {from} to {to} of {total} stations': 'แสดง {from} ถึง {to} จาก {total} สถานี',
  'Get started by adding your first station.': 'เริ่มต้นโดยเพิ่มสถานีแรก',
  'Delete Station': 'ลบสถานี',
  'Are you sure you want to delete {name}? This action cannot be undone.': 'ยืนยันการลบ {name} หรือไม่ การดำเนินการนี้ย้อนกลับไม่ได้',
  'Description': 'รายละเอียด',
  'Latitude': 'ละติจูด',
  'Longitude': 'ลองจิจูด',
  'Number of meters': 'จำนวนมิเตอร์',
  'Diagnostic mode': 'โหมดการวิเคราะห์',
  'Main meter prefix': 'คำนำหน้ามิเตอร์หลัก',
  'Branch meter prefixes': 'คำนำหน้ามิเตอร์วงจรย่อย',
  'No-load threshold': 'เกณฑ์กำลังไฟฟ้าสำหรับตรวจจับการชาร์จ',
  'No-load duration': 'ระยะเวลาที่ไม่พบการชาร์จ',
  'Delete station': 'ลบสถานี',
  'Are you sure you want to delete this station?': 'ยืนยันการลบสถานีนี้หรือไม่',
  'Threshold Settings': 'ตั้งค่าเกณฑ์แจ้งเตือน',
  'Configure voltage and power-factor threshold lines for each station’s History chart.': 'ตั้งค่าเส้นเกณฑ์แรงดันไฟฟ้าและตัวประกอบกำลัง (PF) บนกราฟข้อมูลย้อนหลังของแต่ละสถานี',
  'Voltage Thresholds': 'เกณฑ์แรงดันไฟฟ้า',
  'Leave blank for no threshold (no line is drawn on the chart).': 'เว้นว่างหากไม่ต้องการตั้งค่า (กราฟจะไม่วาดเส้น)',
  'Over Voltage': 'แรงดันเกิน',
  'Under Voltage': 'แรงดันต่ำ',
  'Not set': 'ไม่ตั้งค่า',
  'Red dashed line': 'เส้นประสีแดง',
  'Orange dashed line': 'เส้นประสีส้ม',
  'Show threshold lines in chart': 'แสดงเส้นเกณฑ์ในกราฟ',
  'Show threshold line in chart': 'แสดงเส้นเกณฑ์ในกราฟ',
  'Power Factor Thresholds': 'เกณฑ์ตัวประกอบกำลัง (PF)',
  'Minimum acceptable PF (PF below 0.85 may incur a utility penalty).': 'ค่าตัวประกอบกำลังต่ำสุดที่ยอมรับได้ (PF ต่ำกว่า 0.85 อาจมีค่าปรับจากการไฟฟ้า)',
  'Minimum PF': 'PF ต่ำสุด',
  'Server Alarm Detection': 'การตรวจจับความผิดปกติบนเซิร์ฟเวอร์',
  'Diagnostics require the latest data-message capability marker (enabled_alarms), regardless of board version. Relay alarms remain firmware-controlled.': 'ระบบจะวิเคราะห์เมื่อข้อความข้อมูลล่าสุดมี enabled_alarms โดยไม่ขึ้นกับรุ่นบอร์ด ส่วนสัญญาณเตือนจากรีเลย์ยังคงควบคุมโดยเฟิร์มแวร์',
  'Diagnostics available from the latest capable data message.': 'ข้อความข้อมูลล่าสุดรองรับการวิเคราะห์',
  'Diagnostics unavailable: {reason}.': 'ไม่พร้อมวิเคราะห์: {reason}',
  'waiting for the enabled_alarms key': 'กำลังรอคีย์ enabled_alarms',
  'No diagnostic-capability data has been received for this station yet.': 'ยังไม่ได้รับข้อความข้อมูลที่ยืนยันว่าอุปกรณ์ของสถานีนี้รองรับการวิเคราะห์',
  'Phase-loss voltage (V)': 'แรงดันสำหรับตรวจไฟขาดเฟส (V)',
  'Voltage hysteresis (V)': 'ค่าฮิสเทอรีซิสของแรงดัน (V)',
  'PF hysteresis': 'ค่าฮิสเทอรีซิสของ PF',
  'Minimum current for PF (A)': 'กระแสต่ำสุดสำหรับประเมิน PF (A)',
  'Samples to assert': 'จำนวนตัวอย่างเพื่อยืนยันเหตุ',
  'Samples to clear': 'จำนวนตัวอย่างเพื่อยกเลิกเหตุ',
  'Offline timeout (seconds)': 'เวลาถือว่าออฟไลน์ (วินาที)',
  'Supply-loss voltage (V)': 'แรงดันสำหรับตรวจไฟขาเข้าขาด (V)',
  'No-charging duration (hours)': 'ระยะเวลาไม่พบการชาร์จ (ชั่วโมง)',
  'Enable six-hour no-charging advisory': 'แจ้งข้อแนะนำเมื่อไม่พบการชาร์จต่อเนื่อง 6 ชั่วโมง',
  'Shadow inferred diagnoses (no notifications)': 'โหมดเฝ้าสังเกต (ไม่ส่งการแจ้งเตือนจากผลวิเคราะห์)',
  'Enable notifications for commissioned inferred warnings': 'ส่งการแจ้งเตือนสำหรับคำเตือนจากผลวิเคราะห์ที่เปิดใช้งานแล้ว',
  'Clear values': 'ล้างค่า',
  'Fill Suggested': 'ใส่ค่าที่แนะนำ',
  'Over Voltage must be greater than 0': 'แรงดันเกินต้องมากกว่า 0',
  'Under Voltage must be greater than 0': 'แรงดันต่ำต้องมากกว่า 0',
  'Over Voltage must be greater than Under Voltage': 'แรงดันเกินต้องมากกว่าแรงดันต่ำ',
  'Power Factor must be between 0 and 1': 'ค่าตัวประกอบกำลัง (PF) ต้องอยู่ระหว่าง 0 ถึง 1',
  'Phase Loss voltage must be greater than 0': 'แรงดันตรวจไฟขาดเฟสต้องมากกว่า 0',
  'Debounce samples must be at least 1': 'จำนวนตัวอย่างยืนยันต้องอย่างน้อย 1',
  'Offline timeout must be at least 30 seconds': 'เวลาออฟไลน์ต้องอย่างน้อย 30 วินาที',
  'Leave shadow mode? Inferred diagnoses may become visible warnings after fresh assertion samples.': 'ต้องการออกจากโหมดเฝ้าสังเกตหรือไม่ ผลวิเคราะห์อาจแสดงเป็นคำเตือนหลังได้รับข้อมูลยืนยันชุดใหม่',
  'Thresholds saved': 'บันทึกค่าเกณฑ์แล้ว',
  'Suggested values filled. Select Save to persist them.': 'ใส่ค่าที่แนะนำแล้ว กดบันทึกเพื่อจัดเก็บ',
  'Maximum': 'สูงสุด',
  'Delay': 'เวลาหน่วง',
  'seconds': 'วินาที',
}

const storedLocale = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null
const locale = ref<Locale>(storedLocale === 'th' ? 'th' : 'en')

const interpolate = (message: string, params?: TranslationParams) => {
  if (!params) return message
  return message.replace(/\{(\w+)\}/g, (placeholder, key: string) =>
    Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : placeholder
  )
}

export const t = (message: string, params?: TranslationParams) => {
  const translated = locale.value === 'th' ? (thai[message] ?? message) : message
  return interpolate(translated, params)
}

export const setLocale = (nextLocale: Locale) => {
  locale.value = nextLocale
}

export const useI18n = () => ({
  locale: computed(() => locale.value),
  isThai: computed(() => locale.value === 'th'),
  setLocale,
  t,
})

watch(locale, (nextLocale) => {
  if (typeof window !== 'undefined') window.localStorage.setItem(STORAGE_KEY, nextLocale)
  if (typeof document !== 'undefined') document.documentElement.lang = nextLocale
}, { immediate: true })
